<footer class="main-footer">
  <div class="container-dynamic d-flex">

    <span class="m-auto"></span>
    <span>Developed by </span><span class="kiamisoft"><a href="https://kiamisoft.ao"> Kiamisoft</a></span>
  </div>
</footer>